import { render, staticRenderFns } from "./LegacyProspectsView.vue?vue&type=template&id=0061ad54&scoped=true&"
import script from "./LegacyProspectsView.vue?vue&type=script&lang=js&"
export * from "./LegacyProspectsView.vue?vue&type=script&lang=js&"
import style0 from "./LegacyProspectsView.vue?vue&type=style&index=0&id=0061ad54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061ad54",
  null
  
)

export default component.exports